module.exports = __webpack_public_path__ + "img/paragraphEle.f5dbc298.svg";